import { render, staticRenderFns } from "./password.vue?vue&type=template&id=b2ec184a&scoped=true&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"
import style0 from "./password.vue?vue&type=style&index=0&id=b2ec184a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ec184a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2ec184a')) {
      api.createRecord('b2ec184a', component.options)
    } else {
      api.reload('b2ec184a', component.options)
    }
    module.hot.accept("./password.vue?vue&type=template&id=b2ec184a&scoped=true&", function () {
      api.rerender('b2ec184a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/password.vue"
export default component.exports